"use strict";
require('@js/polyfills/contains');
